module.exports = __webpack_public_path__ + "assets/media/EXTENSION_PREVIEW_IMAGE.0045c7d3.svg";